import React from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import CompanyOnBoardComponent from "../../../components/admin/company/company-on-board/CompanyOnBoardComponent";
import { useHistory } from "react-router";

const CompanyOnBoard = () => {
    const history = useHistory();
    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Company On Board
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Company On Board </h4>
            </div>
            <CompanyOnBoardComponent />
        </Layout>
    );
};
export default CompanyOnBoard;